export const BOOLEAN_OPTION = [
  {
    "label": "Yes",
    "value": true
  },
  {
    "label": "No",
    "value": false
  }
];

export const BOOLEAN_OPTION_PERSONALINFO = [
  {
    "label": "Select",
    "value": ""
  },
  {
    "label": "No",
    "value": "No"
  },
  {
    "label": "Yes",
    "value": "Yes"
  }
];

export const Disability_Certificate = [
  {
    "label": "SADM",
    "id": 1
  },
  {
    "label": "Swavalamban",
    "id": 2
  }
];

export const Division_Armed_Forces = [
  {
    "label": "Army",
    "id": "Army"
  },
  {
    "label": "Navy",
    "id": "Navy"
  },
  {
    "label": "Air Force",
    "id": "Air_Force"
  },
  {
    "label": "Gallantry Award winners of Territorial Army",
    "id": "Gallantry_Award_winners"
  }
];

export const Domicile_AVAILABLE = [
  {
    "label": "Available",
    "id": "Yes"
  },
  {
    "label": "Not Available",
    "id": "No"
  }
];

export const DEBARRED_NATURE = [
  {
    "label": "Permanent",
    "value": 1
  },
  {
    "label": "For certain period",
    "value": 2
  }
];

export const SCRIBE_OPTION = [
  {
    "label": "Self",
    "value": 1
  },
  {
    "label": "BPSC Office",
    "value": 2
  }
];

export const EMPLOYMENT_TYPE = [
  {
    "label": "Past",
    "value": 1
  },
  {
    "label": "Present",
    "value": 2
  }
];

export const GROUP_OPTION = [
  {
    "label": " Group A",
    "value": 1
  },
  {
    "label": "Group B",
    "value": 2
  }
];

export const FULLTIME_OPTION = [
  {
    "label": "Full Time",
    "value": 1
  },
  {
    "label": "Otherwise",
    "value": 2
  }
];

export const RESULTS = [
  {
    "label": "Select",
    "value": ""
  },
  {
    "label": "Passed/Qualified",
    "value": 1
  },
  {
    "label": "Appeared",
    "value": 0
  }
];

// export const AUTHOR_TYPES = [
//   {
//     "label": "Select",
//     "value": ""
//   },
//   {
//     "label": "First Author",
//     "value": 1
//   },
//   {
//     "label": "Second Author",
//     "value": 2
//   },
//   {
//     "label": "Other Author",
//     "value": 3
//   },
//   {
//     "label": "Third",
//     "value": 4
//   },
//   {
//     "label": "Corresponding",
//     "value": 5
//   }
// ];

export const PUBLICAION_TYPES = [
  {
    "label": "Select",
    "value": ""
  },
  {
    "label": "International",
    "value": 1
  },
  {
    "label": "National",
    "value": 2
  },
  {
    "label": "State",
    "value": 3
  },
  {
    "label": "Index Medicus",
    "value": 4
  }
];

export const ORPHAN_TYPE = [
  {
    "label": "Select",
    "value": "",
    "labelForCastListOption": ['323', '324', '325', '326', '327', '328', '329', '330', '331', '332', '333']
  },
  {
    "label": "Orphan Type-A",
    "value": "Orphan Type-A",
    "labelForCastListOption": ['323']
  },
  {
    "label": "Orphan Type-B",
    "value": "Orphan Type-B",
    "labelForCastListOption": ['323', '324', '325', '326', '327', '328', '329', '330', '331', '332', '333']
  },
  {
    "label": "Orphan Type-C",
    "value": "Orphan Type-C",
    "labelForCastListOption": ['323', '324', '325', '326', '327', '328', '329', '330', '331', '332', '333']
  }
];
// export const FULLTIME_OPTION = [
//   {
//     "label": "Full Time",
//     "value": 1
//   },
//   {
//     "label": "Otherwise",
//     "value": 2
//   }
// ];

// export const BOOLEAN_OPTION = [
//   {
//     "label": "Yes",
//     "value": true
//   },
//   {
//     "label": "No",
//     "value": false
//   }
// ];

export const stageTypeList = [
  {
    id: 1,
    value: "Syllabus"
  },
  {
    id: 2,
    value: "Exam"
  },
  {
    id: 3,
    value: "First Answer Key"
  },
  {
    id: 4,
    value: "Final Answer Key"
  },
  {
    id: 5,
    value: "Result"
  },
  {
    id: 6,
    value: "Scrutiny"
  },
  {
    id: 7,
    value: "Physical Test"
  },
  {
    id: 8,
    value: "Interview"
  },
  {
    id: 9,
    value: "Merit"
  },
  {
    id: 10,
    value: "Final Result"
  },
  {
    id: 11,
    value: "Recommendation"
  },
];

export const stageDeskList = [
  {
    id: 1,
    value: "Desk 1",
    stageId: 0
  },
  {
    id: 2,
    value: "Desk 2",
    stageId: 0
  },
  {
    id: 3,
    value: "Desk 3",
    stageId: 0
  },
  {
    id: 4,
    value: "Desk 4",
    stageId: 0
  },
  {
    id: 5,
    value: "Desk 5",
    stageId: 0
  },
  {
    id: 6,
    value: "Desk 6",
    stageId: 0
  },
  {
    id: 7,
    value: "Desk 7",
    stageId: 0
  },
  {
    id: 8,
    value: "Desk 8",
    stageId: 0
  },
  {
    id: 9,
    value: "Desk 9",
    stageId: 0
  },
  {
    id: 10,
    value: "Desk 10",
    stageId: 0
  },
  {
    id: 11,
    value: "Desk 11",
    stageId: 0
  },
  {
    id: 12,
    value: "Desk 12",
    stageId: 0
  },
  {
    id: 13,
    value: "Desk 13",
    stageId: 0
  },
  {
    id: 14,
    value: "Desk 14",
    stageId: 0
  },
  {
    id: 15,
    value: "Desk 15",
    stageId: 0
  },
  {
    id: 16,
    value: "Desk 16",
    stageId: 0
  },
  {
    id: 17,
    value: "Desk 17",
    stageId: 0
  },
  {
    id: 18,
    value: "Desk 18",
    stageId: 0
  },
  {
    id: 19,
    value: "Desk 19",
    stageId: 0
  },
  {
    id: 20,
    value: "Desk 20",
    stageId: 0
  },
  {
    id: 21,
    value: "Desk 21",
    stageId: 0
  },
  {
    id: 22,
    value: "Desk 22",
    stageId: 0
  },
  {
    id: 23,
    value: "Desk 23",
    stageId: 0
  },
  {
    id: 24,
    value: "Desk 24",
    stageId: 0
  },
  {
    id: 25,
    value: "Desk 25",
    stageId: 0
  },
  {
    id: 26,
    value: "Desk 26",
    stageId: 0
  },
  {
    id: 27,
    value: "Desk 27",
    stageId: 0
  },
  {
    id: 28,
    value: "Desk 28",
    stageId: 0
  },
  {
    id: 29,
    value: "Desk 29",
    stageId: 0
  },
  {
    id: 30,
    value: "Desk 30",
    stageId: 0
  },
  {
    id: 31,
    value: "Desk 31",
    stageId: 0
  },
];

export const reqStatusList = [
  {
    id: 1,
    value: "NA"
  },
  {
    id: 2,
    value: "Pending"
  },
  {
    id: 3,
    value: "In Process"
  },
  {
    id: 4,
    value: "Completed"
  },
];

export const advtTypeArray = [
  {
    "id": "1",
    "type": "Active Advertisements"
  },
  {
    "id": "2",
    "type": "Past Advertisements"
  }
];

export const interviewPtLetterHeaderField = [
  {
    id: "1",
    steps: "Step 1",
    name: "Configuration",
    code: "configurationTab",
  },
  {
    id: "2",
    steps: "Step 2",
    name: "Content",
    code: "contentTab",
  },
  {
    id: "3",
    steps: "Step 3",
    name: "Report",
    code: "ReportTab",
  },
  {
    id: "4",
    steps: "Step 4",
    name: "Notification",
    code: "notificationTab",
  }
];

export const interviewReportDropdownData = [
  {
    id: 1,
    name: "Interview Report",
  },
  {
    id: 2,
    name: "Interview Muster",
  }
];

export const AUTHOR_TYPES = [
  {
    "label": "Select",
    "value": ""
  },
  {
    "label": "First Author",
    "value": 1
  },
  {
    "label": "Second Author",
    "value": 2
  },
  {
    "label": "Other Author",
    "value": 3
  },
  {
    "label": "Third",
    "value": 4
  },
  {
    "label": "Corresponding",
    "value": 5
  }
];


